class ProductOption {
	constructor({
		id = '',
		productId = '',
		name = '',
		extraUsd = '',
		extraKrw = '',
		useYn = 0,
	} = {}) {
		this.id = id === null ? '' : id
		this.productId = productId === null ? '' : productId
		this.name = name === null ? '' : name
		this.extraUsd = extraUsd === null ? '' : extraUsd
		this.extraKrw = extraKrw === null ? '' : extraKrw
		this.useYn = useYn === null ? 0 : useYn
	}
	id: string
	productId: string
	name: string
	extraUsd: string
	extraKrw: string
	useYn: number
}

export { ProductOption }
